import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  // eslint-disable-next-line import/prefer-default-export
  const AddressFragment = gql`
fragment AddressFragment on Address {
  id
  line1
  line2
  city
  state
  country
  venue
  zipCode
}
`;

  return {
    AddressFragment,
  };
};
